import type React from 'react';
import type { ComponentPropsWithoutRef } from 'react';
import { forwardRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { DialogStateManager } from '../../dialog/dialog-provider.tsx';
import { DraftOrderCreateDialog } from './draft-order-create-dialog.tsx';

type CreateNewDraftLinkProps = {
    customerId?: string;
} & Omit<ComponentPropsWithoutRef<'a'>, 'to'>;

export const CreateNewDraftLink = forwardRef<React.ElementRef<'a'>, CreateNewDraftLinkProps>(
    ({ customerId, ...props }, ref) => {
        const navigate = useNavigate();

        const handleCreateNewDraft = (e: { preventDefault: () => void }) => {
            e.preventDefault();

            DialogStateManager.show(DraftOrderCreateDialog, {
                customerId: customerId,
                onSuccess: (data) => {
                    navigate(`/drafts/${data.draft_order.draft_order_id}/line-items`);
                },
            });

            return null;
        };

        return (
            <a
                {...props}
                className="text-blue-700 hover:underline"
                onClick={handleCreateNewDraft}
                ref={ref}
            />
        );
    },
);

CreateNewDraftLink.displayName = 'CreateNewDraftLinkTag';
